import { CheckboxDataGroup } from "components/components/CheckboxList/CheckboxList";

const QueueFilterCategoryNames = {
  PRICING_PARAMETERS: "Pricing parameters",
  DERIVED_DATA: "Derived data and pricing calculations",
  BM_DATA: "Balancing Mechanism data",
  LONG_TERM: "Long-term availability and outages",
  GENERATION_AND_DEMAND: "Generation and demand (Balancing Mechanism)",
  TRANSPARENCY: "EU transparency data",
  MARKET_MESSAGES: "Market messages and REMIT",
  SETTLEMENT_DATA: "Settlement data",
  OTHER: "Other",
} as const;

type QueueFilterCategoryName =
  typeof QueueFilterCategoryNames[keyof typeof QueueFilterCategoryNames];

const queueFilterCategories: Record<QueueFilterCategoryName, string[]> = {
  [QueueFilterCategoryNames.PRICING_PARAMETERS]: [
    "PN",
    "BOD",
    "BOALF",
    "DISBSAD",
    "NETBSAD",
    "QPN",
    "MID",
    "LOLPDM",
    "NONBM",
  ],
  [QueueFilterCategoryNames.DERIVED_DATA]: [
    "SMSG",
    "DISEBSP",
    "ISPSTACK",
    "BOAV",
    "DISPTAV",
    "EBOCF",
  ],
  [QueueFilterCategoryNames.BM_DATA]: [
    "PN",
    "BOD",
    "BOALF",
    "MILS",
    "MELS",
    "FREQ",
    "SIL",
    "SEL",
    "QAS",
    "MDO",
    "MDB",
    "MDV",
    "MDP",
    "RURE",
    "RURI",
    "RDRE",
    "RDRI",
    "NTB",
    "NTO",
    "MZT",
    "MNZT",
    "NDZ",
  ],
  [QueueFilterCategoryNames.LONG_TERM]: [
    "UOU2T3YW",
    "FOU2T3YW",
    "NOU2T3YW",
    "OCNMF3Y2",
    "OCNMF3Y",
  ],
  [QueueFilterCategoryNames.GENERATION_AND_DEMAND]: [
    "FREQ",
    "FUELINST",
    "FUELHH",
    "FOU2T14D",
    "NOU2T14D",
    "UOU2T14D",
    "NDF",
    "NDFD",
    "NDFW",
    "TSDF",
    "TSDFD",
    "TSDFW",
    "IMBALNGC",
    "INDDEM",
    "INDGEN",
    "MELNGC",
    "OCNMFD",
    "OCNMFD2",
    "OCNMFW",
    "OCNMFW2",
    "AGWS",
    "AGPT",
    "DGWS",
    "INDO",
    "INDOD",
    "ITSDO",
    "WINDFOR",
    "RZDF",
    "RZDR",
  ],
  [QueueFilterCategoryNames.TRANSPARENCY]: [
    "ATL",
    "DATL",
    "MATL",
    "WATL",
    "YATL",
    "ABUC",
    "AGPT",
    "AGWS",
    "AOBE",
    "BEB",
    "CBS",
    "CCM",
    "DAG",
    "DGWS",
    "FEIB",
    "IGCA",
    "IGCPU",
    "PBC",
    "PPBR",
    "YAFM",
  ],
  [QueueFilterCategoryNames.MARKET_MESSAGES]: ["REMIT", "SYS_WARN", "E0361"],
  [QueueFilterCategoryNames.SETTLEMENT_DATA]: ["B1610", "TUDM"],
  [QueueFilterCategoryNames.OTHER]: ["SOSO", "TEMP", "DCI"],
};

export const queueFilterCheckboxListDefinition: CheckboxDataGroup[] =
  ((): CheckboxDataGroup[] => {
    const checkboxData: CheckboxDataGroup[] = [];
    let idCounter = 0;

    Object.entries(queueFilterCategories).forEach(
      ([categoryName, datasets]) => {
        const parentId = idCounter;
        checkboxData.push({
          id: parentId,
          name: categoryName,
          parentId: null,
        });
        idCounter++;

        datasets.forEach((dataset) => {
          checkboxData.push({
            id: idCounter,
            name: dataset,
            parentId: parentId,
            datasets: [dataset],
          });
          idCounter++;
        });
      }
    );

    return checkboxData;
  })();
